// extracted by mini-css-extract-plugin
export default {"header":"custom_header__0ezQe"};